import React, { useState, useEffect, useMemo } from "react";
import "./WelcomeModal.css";
import modal_logo from '../../../../_assets/img/modal_logo.png'
import modal_logo_min from "../../../../_assets/img/modal_logo_min.png";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Button } from "primereact/button";

// Substitua o FEATURES atual por este:
const FEATURES = [
  {
    key: "AreaMeasurer",
    title: "Medidor de Área",
    desc: "Desenhe polígonos e meça áreas (m²/ha/km²). Permite copiar o resultado.",
  },
  {
    key: "BaseLayer",
    title: "Mapa Base",
    desc: "Troque entre satélite, rua, terreno etc. Ajuste a opacidade do fundo.",
  },
  {
    key: "DistanceMeasurer",
    title: "Medidor de Distância",
    desc: "Meça distâncias com linhas/polilinhas e acumulado por segmento.",
  },
  {
    key: "FeatureInfo",
    title: "Informação da Feição",
    desc: "Clique no mapa para ver atributos da feição. Abre tabela/links quando houver.",
  },
  {
    key: "FileUploader",
    title: "Importar Arquivos",
    desc: "Carregue GeoJSON, Shapefile (zip), KML ou CSV e visualize no mapa.",
  },
  {
    key: "GovFooterBar",
    title: "Rodapé Institucional",
    desc: "Créditos, contato, termos e links úteis do projeto.",
  },
  {
    key: "GovHeaderBar",
    title: "Cabeçalho",
    desc: "Logomarcas, navegação e atalhos principais da plataforma.",
  },
  {
    key: "GridLayer",
    title: "Grade Cartográfica",
    desc: "Exibe grade (UTM/Latitude-Longitude) configurável sobre o mapa.",
  },
  {
    key: "HintWindow",
    title: "Dicas em Contexto",
    desc: "Mensagens curtas que explicam a ferramenta ativa e como usá-la.",
  },
  {
    key: "HorizontalToolbarToggler",
    title: "Mostrar/Ocultar Ferramentas",
    desc: "Alterna a barra de ferramentas horizontal para ganhar espaço.",
  },
  {
    key: "LayerSwitcher",
    title: "Gerenciador de Camadas",
    desc: "Liga/desliga camadas, organiza grupos, reordena e ajusta opacidade.",
  },
  {
    key: "LegendPopup",
    title: "Legenda Rápida",
    desc: "Mostra a legenda da camada ativa conforme o estilo do GeoServer.",
  },
  {
    key: "LocateAddress",
    title: "Buscar Endereço",
    desc: "Geocodifique endereços/lugares e faça zoom para a localização.",
  },
  {
    key: "LocateMe",
    title: "Minha Localização",
    desc: "Centraliza no GPS do navegador e pode acompanhar movimento.",
  },
  {
    key: "MapWrapper",
    title: "Container do Mapa",
    desc: "Orquestração do mapa e eventos (infraestrutura do módulo).",
  },
  {
    key: "MouseWatcher",
    title: "Coordenadas do Mouse",
    desc: "Exibe latitude/longitude (ou UTM) e escala sob o cursor.",
  },
  {
    key: "Navbar",
    title: "Navegação",
    desc: "Menu principal entre módulos e páginas da plataforma.",
  },
  {
    key: "PngExporter",
    title: "Exportar PNG",
    desc: "Gera imagem do mapa com título, escala e data (quando configurado).",
  },
  {
    key: "ResetRotation",
    title: "Resetar Rotação",
    desc: "Restaura a orientação do mapa para 0°.",
  },
  {
    key: "ResetZoom",
    title: "Enquadramento Padrão",
    desc: "Volta para a extensão inicial do projeto.",
  },
  {
    key: "ScaleBar",
    title: "Barra de Escala",
    desc: "Escala gráfica dinâmica de acordo com o nível de zoom.",
  },
  {
    key: "StatisticGraphics",
    title: "Gráficos Estatísticos",
    desc: "Gera gráficos (barras/pizza/linhas) a partir de seleção ou camada.",
  },
  {
    key: "StoryTelling",
    title: "Storytelling",
    desc: "Narrativas guiadas com páginas, mapas, texto, imagens e gráficos.",
  },
  {
    key: "LayerFilter",
    title: "Filtro de Camada (CQL)",
    desc: "Filtre por atributos/expressões CQL. Salve e reutilize filtros.",
  },
  {
    key: "LayerScope",
    title: "Escopo da Camada",
    desc: "Define recortes/zoom para a camada ativa (limites e foco).",
  },
  {
    key: "LegendGraphic",
    title: "Legenda Gráfica (GeoServer)",
    desc: "Baixa/exibe a legenda gerada pelo SLD do GeoServer (raster/SVG).",
  },
];

const TABS = ["inicio", "funcionalidades", "outras"];

const WelcomeModal = ({ active, callback }) => {
  const { t } = useTranslation();
  const clientWidth = document.documentElement.clientWidth;

  const bootstrapFooterCheckClass = clientWidth <= 1000 ? "row" : "col-9";

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [agreeTerms, setAgreeTerms] = useState(false);
  const [agreePrivacy, setAgreePrivacy] = useState(false);

  const [tab, setTab] = useState("inicio");
  const canFinish = agreeTerms && agreePrivacy;
  const tabIndex = useMemo(() => TABS.indexOf(tab), [tab]);
  const isFirst = tabIndex === 0;
  const isLast = tabIndex === TABS.length - 1;

  const goNext = () => !isLast && setTab(TABS[tabIndex + 1]);
  const goPrev = () => !isFirst && setTab(TABS[tabIndex - 1]);

  useEffect(() => {
    if (active) handleShow();
  }, [active]);

  useEffect(() => {
    callback(show);
  }, [show]);

  useEffect(() => {
    if (
      sessionStorage.getItem("FirstAccess") === undefined ||
      sessionStorage.getItem("FirstAccess") === null
    ) {
      sessionStorage.setItem("FirstAccess", true);
    }

    if (sessionStorage.getItem("FirstAccess") === "true") {
      handleShow();
      sessionStorage.setItem("FirstAccess", false);
    }
  }, []);

  return (
    <Modal
      className="WelcomeModal"
      backdrop="static"
      keyboard={false}
      size="xl"
      show={show}
      onHide={handleClose}
    >
      <div className="ContainerLogo">
          <img
          className="img-thumbnail"
          alt="Logo"
          title="Logo"
          src={clientWidth > 350 ? modal_logo : modal_logo_min}
        />
      
      
      </div>

      <div className="tab-nav-bar px-4 pt-3 d-flex justify-content-center">
        <ul className="nav nav-pills gap-2 flex-wrap">
          {TABS.map((t) => (
            <li className="nav-item" key={t}>
              <Button
                className={`BtnsWelcomeModal ${tab === t ? "active" : ""}`}
                onClick={() => setTab(t)}
                type="button"
                raised
                outlined
              >
                {t === "inicio" && "Início"}
                {t === "funcionalidades" && "Ferramentas"}
                {t === "outras" && "Outras funcionalidades"}
              </Button>
            </li>
          ))}
        </ul>
      </div>

      <Modal.Body>
        {tab === "inicio" && (
          <section>
            <h4>{t("welcomeModal.title")}</h4>
            <p className="ModalText">{t("welcomeModal.section1.0")}</p>
            <p className="ModalText">{t("welcomeModal.section1.1")}</p>

            <br />
            <h4>{t("welcomeModal.termsTitle")}</h4>
            <p className="ModalText">{t("welcomeModal.section2.0")}</p>
            <p className="ModalText">{t("welcomeModal.section2.1")}</p>

            <a
              className="TermLink"
              href="/portal/termos_e_condicoes_de_uso_pedea.pdf"
              target="_blank"
              rel="noreferrer"
            >
              {t("welcomeModal.readTerms")}
            </a>

            <br />
            <br />
            <h4>{t("welcomeModal.privacyTitle")}</h4>
            <p className="ModalText">{t("welcomeModal.section3.0")}</p>
            <p className="ModalText">{t("welcomeModal.section3.1")}</p>

            <a
              className="TermLink"
              href="/portal/aviso_privacidade_pedea.pdf"
              target="_blank"
              rel="noreferrer"
            >
              {t("welcomeModal.readPrivacy")}
            </a>

            <br />
            <br />

            <div className="WelcomeModalFooter row">
              <div className={bootstrapFooterCheckClass}>
                <div className="TermCheckBox form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={agreeTerms}
                    onChange={() => setAgreeTerms(!agreeTerms)}
                    id="checkTermAndConditions"
                  />
                  <label
                    className="form-check-label"
                    htmlFor="checkTermAndConditions"
                  >
                    {t("welcomeModal.checkboxTerms")}
                  </label>
                </div>
                <div className="TermCheckBox form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={agreePrivacy}
                    onChange={() => setAgreePrivacy(!agreePrivacy)}
                    id="checkLegalWarning"
                  />
                  <label
                    className="form-check-label"
                    htmlFor="checkLegalWarning"
                  >
                    {t("welcomeModal.checkboxPrivacy")}
                  </label>
                </div>
              </div>
            </div>
          </section>
        )}

        {tab === "funcionalidades" && (
          <section>
            <h4>Ferramentas</h4>
            <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-xl-4 g-3">
              {FEATURES.map((f) => (
                <div className="col" key={f.key}>
                  <div className="card CardFerramentas">
                    <div className="card-body">
                      <h6 className="card-title mb-1">{f.title}</h6>
                      <p className="card-text small ">
                        {f.desc}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>
        )}

        {tab === "outras" && (
          <section >
            <h4>Outras Funcionalidades</h4>
            <div className="ContainerOutrasFuncionalidades">
              <div className="containersInfos">
                <div className="card-body">
                  <h6 className="card-title">FAQ</h6>
                  <p className="card-text small text-muted">
                    Dúvidas frequentes sobre uso e dados.
                  </p>
                  <a
                    href="/portal/faq.html"
                    target="_blank"
                    className="btn btn-outline-primary btn-sm"
                    style={{ borderRadius: "10px" }}
                  >
                    Abrir FAQ
                  </a>
                </div>
              </div>
              <div className="containersInfos">
                <div className="card-body">
                  <h6 className="card-title">Histórico evolutivo</h6>
                  <p className="card-text small text-muted">
                    Versões, melhorias e correções.
                  </p>
                  <a
                    href="/portal/versioning.html"
                    target="_blank"
                    className="btn btn-outline-primary btn-sm"
                    style={{ borderRadius: "10px" }}
                  >
                    Ver histórico
                  </a>
                </div>
              </div>
              <div className="containersInfos">
                <div className="card-body">
                  <h6 className="card-title">Portal de Dados</h6>
                  <p className="card-text">
                    Metadados, mapas e site administrativo.
                  </p>
                  <a
                    href="https://pedea.sema.ce.gov.br/gestor"
                    target="_blank"
                    className="btn btn-outline-primary btn-sm"
                    style={{ borderRadius: "10px" }}
                  >
                    Guia de acesso
                  </a>
                </div>
              </div>
              <div className="containersInfos">
                <div className="card-body">
                  <h6 className="card-title">Acesso & Download (GeoServer)</h6>
                  <p className="card-text small text-muted">
                    WMS/WFS/WCS, CQL e exemplos de requisição.
                  </p>
                  <a
                    href="https://pedea.sema.ce.gov.br/geoserver"
                    target="_blank"
                    className="btn btn-outline-primary btn-sm"
                    style={{ borderRadius: "10px" }}
                  >
                    Guia de acesso
                  </a>
                </div>
              </div>
            </div>
          </section>
        )}
      </Modal.Body>

      <Modal.Footer>
        <div className="px-4 pb-4 d-flex flex-wrap gap-2 justify-content-between align-items-center">
          <div className="text-muted small">
            Passo {tabIndex + 1} de {TABS.length}
          </div>
          <div className="containerBtns">
            {tab === "inicio" && (
              <Button
                severity="success"
                raised
                icon="pi pi-check"
                onClick={handleClose}
                disabled={!canFinish}
                style={{ borderRadius: "10px", display: "flex", gap: "10px" }}
              >
                Concordo e continuar
              </Button>
            )}
            <Button
              severity="secondary"
              raised
              icon="pi pi-arrow-circle-left"
              onClick={goPrev}
              disabled={isFirst}
              style={{ borderRadius: "10px", display: "flex", gap: "10px" }}
            >
              Voltar
            </Button>
            {!isLast && (
              <Button
                severity="info"
                raised
                icon="pi pi-arrow-circle-right"
                onClick={goNext}
                disabled={tab === "inicio" && !canFinish}
                style={{ borderRadius: "10px", display: "flex", gap: "10px" }}
              >
                Próximo
              </Button>
            )}
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default WelcomeModal;
